import { Panel } from './Panel';
import { createElement, createInputElement } from '../utils';

class SettingsPanel extends Panel {
    settingsList: HTMLElement;

    constructor(id: string, hidden: boolean) {
        super(id, hidden);

        // clean up accordion
        this.panelElement.innerHTML = '';
        this.panelElement.classList.add('settings-panel');

        this.settingsList = document.createElement('ul');
        this.settingsList.className = 'settingsList';

        this.panelElement.appendChild(this.settingsList);
    }

    hideSettingsItem(id: string) : void {
        const _id = "li_" + id;
        this.settingsList.querySelector('#' + _id)?.classList.add('hidden');
    }

    showSettingsItem(id: string) : void {
        const _id = "li_" + id;
        this.settingsList.querySelector('#' + _id)?.classList.remove('hidden');
    }

    addSwitch(name: string, id: string, callback: (ev: MouseEvent) => unknown, bChecked: undefined) : HTMLLIElement {
        const li = document.createElement("li");
        li.className = "switch hidden";
        li.id = 'li_' + id;

        const label = document.createElement("label");
        const textNode = document.createTextNode(" " + name);
        const span = document.createElement("span");
        span.className = "lever";

        const input = document.createElement("input");
        input.id = id;
        input.type = 'checkbox';
        input.onclick = callback;
        if (bChecked)
            input.checked = true;

        label.appendChild(textNode);
        label.appendChild(input);
        label.appendChild(span);
        li.appendChild(label);
        this.settingsList.appendChild(li);

        return li;
    }

    addCombo(name: string, id: string, values: string[][], callback: (ev: Event) => unknown, selected: string|undefined) : HTMLLIElement {
        const li = document.createElement("li");
        li.id = 'li_' + id;

        const label = document.createElement("label");
        const textNode = document.createTextNode(" " + name);

        const input = document.createElement("select");
        input.classList.add("settingsCombo");
        input.id = id;
        input.onchange = callback;

        for (const value of values) {
            const option = document.createElement("option");
            option.value = value[0];
            input.appendChild(option);
            option.appendChild(document.createTextNode(value[1]));
        }

        if (selected!==undefined)
            input.value = selected;
        label.appendChild(textNode);
        label.appendChild(input);
        li.appendChild(label);
        this.settingsList.appendChild(li);

        return li;
    }

    addItem(id: string, item_text: string, item_source: HTMLElement, bBlock = false) : HTMLLIElement {
        const li = document.createElement("li");
        li.id = "li_" + id;

        if (item_text) {
            const label = document.createElement("label");
            const textNode = document.createTextNode(item_text);
            label.appendChild(textNode);
            li.appendChild(label);
        }
        if (bBlock) {
            li.appendChild(document.createElement("br"));
        }
        li.appendChild(item_source);
        this.settingsList.appendChild(li);

        return li;
    }

    addSeparator(id: string) : void {
        const li = document.createElement("li");
        if (id!==undefined)
          li.id = "li_" + id;
        const hr = document.createElement("hr");
        hr.className = "separatorHR";
        li.appendChild(hr);
        this.settingsList.appendChild(li);
    }

    addButtonItem(id: string, item_text: string, callback:() => unknown, bBlock: number | boolean, disabled: boolean, isPassword: boolean, label: string) : void {
        const li = createElement(this.settingsList, "li");
        const container = createElement(li, "div");
        container.className = 'settingsTextContainer';

        if (label) {
            const text = createElement(container, "span");
            text.innerHTML = label;

            if (bBlock) createElement(container, "br"); //??
        }

        const input_edit = createInputElement(container, "text", "settingsTextEdit", id);
        if (disabled) {
            input_edit.setAttribute("disabled", "disabled");
            input_edit.setAttribute("readonly", "readonly");
        }
        input_edit.type = isPassword ? "password" : "text";

        if (item_text) {
            if (bBlock === true)
                bBlock = 1;
            for (let i = 0; i < (bBlock as number); i++) createElement(container, "br"); //??

            const input_btn = createInputElement(container, "button", "settingsButton");
            input_btn.value = item_text;
            input_btn.onclick = function() {
                callback();
                return true;
            }
        }
    }
}

export { SettingsPanel };